import axios from 'axios';

const ROOT_URL = "https://todis.transport-community.org/api/";
//const ROOT_URL = "http://localhost:8080/api/";

class EmailService {

    async sendEmail(email) {
        try {
            const response = await axios.post(ROOT_URL + `workflow/resetPassword`, { email });
            return response.data;
        } catch (error) {
            throw new Error('Failed to send email');
        }
    }

    static async sendGroupEmail( recipients, subject, body ) {
        try {
            const response = await axios.post(ROOT_URL + `workflow/groupNotification/users`, { recipients, subject, body });
            return response.data;
        } catch (error) {
            throw new Error('Failed to send group email');
        }
    }

    static async sendGroupEmailRoles( recipients, subject, body ) {
        try {
            const response = await axios.post(ROOT_URL + `workflow/groupNotification/roles`, { recipients, subject, body });
            return response.data;
        } catch (error) {
            throw new Error('Failed to send group email');
        }
    }

    static async sendGroupEmailOrgs( recipients, subject, body ) {
        try {
            const response = await axios.post(ROOT_URL + `workflow/groupNotification/organizations`, { recipients, subject, body });
            return response.data;
        } catch (error) {
            throw new Error('Failed to send group email');
        }
    }

    static async sendGroupEmailRegPartners( recipients, subject, body ) {
        try {
            const response = await axios.post(ROOT_URL + `workflow/groupNotification/regionalPartners`, { recipients, subject, body });
            return response.data;
        } catch (error) {
            throw new Error('Failed to send group email');
        }
    }
}

export default EmailService;